module.exports = __webpack_public_path__ + "static/media/BIRTHDAY_SURPRISE_60X50.ada13397.svg";